// React wrapper for the shared inlineMdToHtml parser. The pure function
// lives at src/shared/inline-md.ts so the worker can use it during
// newsletter HTML rendering without pulling in React.

import { inlineMdToHtml } from '@shared/inline-md';

export { inlineMdToHtml };

// React component — just hand the parsed HTML to dangerouslySetInnerHTML.
// The parser controls every byte that goes in there, so this is safe.
export function RichInline({ md }: { md: string | undefined | null }) {
  return <span dangerouslySetInnerHTML={{ __html: inlineMdToHtml(md || '') }} />;
}
